import { HostingSiteAddBodyDatacenter } from '@newfold/huapi-js/src/index.schemas';

import { NUMERIC_KEYBOARD_INPUT_REGEX } from '~/utils/regex/constants';

export const getDataCenterLocations = () => {
  // Reversing to prevent Amsterdam from being first in the list - until we get a dynamic solution from Atomic
  return Object.values(HostingSiteAddBodyDatacenter)
    .map((value) => value)
    .reverse();
};

// used in Storage.tsx and Workers.tsx
export const blockInvalidNumberChar = (
  e: React.KeyboardEvent<HTMLDivElement>,
) => {
  return !e.key.match(NUMERIC_KEYBOARD_INPUT_REGEX) && e.preventDefault();
};

export const getMultisiteNetworkConfigOptions = (
  t: (key: string) => string,
) => [
  {
    key: 'subdomain',
    testId: 'multisite-subdomain-option',
    title: t('multisiteInfo.subDomainLabel'),
    description: t('multisiteInfo.subDomainPlaceholder'),
  },
  {
    key: 'subdirectory',
    testId: 'multisite-subdirectory-option',
    title: t('multisiteInfo.subDirectoryLabel'),
    description: t('multisiteInfo.subDirectoryPlaceholder'),
  },
];
